import { action, makeObservable, observable } from 'mobx'
import { greaterThanOrEqual } from 'utils/validation-utils'
import { required, validationContext } from 'validx'
import {
  IInventoryItemPricingEditor,
  InventoryItemFlatValues,
  InventoryItemPricingValues,
} from './inventory-item-pricing-editor'
import { InventoryItemPricing } from 'admin/inventory/InventoryItem'

/**
 * View Model for Inventory Items of type Flat.
 */
export class FlatEditorViewModel implements IInventoryItemPricingEditor {
  /**
   * The client amount for the Inventory Item. This is the amount the client will
   * be charged.
   */
  clientAmount = 0

  /**
   * The pro payout amount for the Inventory Item. This is the amount the pro will
   * receive.
   */
  proPayoutAmount = 0

  /**
   * Validation context.
   */
  validation = validationContext(this, {
    clientAmount: [
      required('A client price is required.'),
      greaterThanOrEqual(0, 'The amount must be zero or greater.'),
    ],

    proPayoutAmount: [
      required('A pro payout amount is required.'),
      greaterThanOrEqual(0, 'The amount must be zero or greater.'),
    ],
  })

  constructor() {
    makeObservable(this, {
      clientAmount: observable,
      proPayoutAmount: observable,
      hydrate: action.bound,
      reset: action.bound,
    })
  }

  /**
   * @inheritdoc
   */
  validate(): boolean {
    return this.validation.reset().validate().isValid
  }

  /**
   * @inheritdoc
   */
  hydrate(values: InventoryItemFlatValues): void {
    this.clientAmount = values.clientPrice
    this.proPayoutAmount = values.proPayoutAmount
  }

  /**
   * @inheritdoc
   */
  toValues(): InventoryItemPricingValues {
    return {
      type: InventoryItemPricing.Flat,
      clientPrice: this.clientAmount,
      proPayoutAmount: this.proPayoutAmount,
    }
  }

  /**
   * @inheritdoc
   */
  reset() {
    this.clientAmount = 0
    this.proPayoutAmount = 0
    this.validation.reset()
  }
}
